import { API_BASE_URL } from '../../../../config';

/** Build URL for document file (admin preview). */
export function buildDocumentFileUrl(
  email: string,
  invitationId: string,
  docCode: string,
  submissionRound?: number,
  side?: 'front' | 'back'
): string {
  const params: Record<string, string> = {
    email: email.trim(),
    invitationId: invitationId.trim(),
    docCode: docCode.trim(),
  };
  if (submissionRound != null) params.submissionRound = String(submissionRound);
  if (side === 'back') params.side = 'back';

  return `${API_BASE_URL}/api/chat-flow/documents/file?${new URLSearchParams(params).toString()}`;
}

/** True if filename extension is an image we can show in <img>. */
export function isImageExtension(filePath: string | null): boolean {
  if (!filePath) return false;
  const lower = filePath.toLowerCase();
  return (
    lower.endsWith('.jpg') ||
    lower.endsWith('.jpeg') ||
    lower.endsWith('.png') ||
    lower.endsWith('.gif') ||
    lower.endsWith('.webp')
  );
}

/** True if filename extension is PDF. */
export function isPdfExtension(filePath: string | null): boolean {
  return filePath != null && filePath.toLowerCase().endsWith('.pdf');
}

/** Make a string safe for use as a filename (remove/replace invalid chars). */
export function safeFileNamePart(s: string): string {
  return s.replace(/[/\\:*?"<>|]/g, '_').replace(/\s+/g, '_').trim() || 'file';
}

/**fetches the document from API and triggers a browser download */
export async function downloadDocumentFile(
  url: string,
  suggestedFilename:string
):Promise<void>{

  const response = await fetch(url, { credentials: 'include' });
  if(!response.ok) throw new Error ("ダウンロードに失敗しました");
  const blob = await response.blob();

  const contentType = response.headers.get('content-type') || '';
  const hasExtension = /\.[a-z0-9]+$/i.test(suggestedFilename);
  const inferredExt =
    contentType.includes('pdf') ? '.pdf'
    : contentType.includes('png') ? '.png'
    : (contentType.includes('jpeg') || contentType.includes('jpg')) ? '.jpg'
    : contentType.includes('gif') ? '.gif'
    : contentType.includes('webp') ? '.webp'
    : '';
  const finalFilename =
    suggestedFilename && hasExtension ? suggestedFilename
    : suggestedFilename ? `${suggestedFilename}${inferredExt}`
    : `document${inferredExt || ''}`;

  //create a temporary link <a> to trigger the download
  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = blobUrl;
  //set the download attribute to suggest a filename
  a.download = finalFilename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(blobUrl);
};

